import {
  DensityUnitSelectField,
  DimensionUnitSelectField,
  PackedOnSelectField,
  RangeField,
  StorageTypeSelectField,
  StrappingSelectField,
  TextField,
  useFormContext,
  useWatch,
} from 'form';
import { useTranslation } from 'i18n';
import { Stack, Typography } from 'ui';

import { PackagingSpecificationType } from '../../pages/schema';

export const PackagingSpecificationForm = () => {
  const { t } = useTranslation('orders');
  const form = useFormContext<PackagingSpecificationType>();
  const [dimensionUnit, densityUnit] = useWatch({
    control: form.control,
    name: ['dimension_unit', 'density_unit'],
  });
  return (
    <Stack spacing={2}>
      <TextField
        label={t('packagingSpecificationForm.labels.alias')}
        name="title"
        placeholder={t('packagingSpecificationForm.placeholders.name')}
      />
      <StorageTypeSelectField name="storage_type" label={t('packagingSpecificationForm.labels.storageType')} required />
      <PackedOnSelectField name="packed_on" label={t('packagingSpecificationForm.labels.packedOn')} />
      <StrappingSelectField name="strapping" label={t('packagingSpecificationForm.labels.strapping')} multiple />

      <Typography variant="body1" fontWeight="bold">
        {t('packagingSpecificationForm.sections.weight')}
      </Typography>
      <RangeField
        minName="min_weight"
        maxName="max_weight"
        label={t('packagingSpecificationForm.labels.unitWeight')}
        endAdornment={t('packagingSpecificationForm.units.kg')}
      />
      <RangeField
        minName="min_load_weight"
        maxName="max_load_weight"
        label={t('packagingSpecificationForm.labels.loadWeight')}
        endAdornment={t('packagingSpecificationForm.units.mt')}
      />

      <Typography variant="body1" fontWeight="bold">
        {t('packagingSpecificationForm.sections.dimensions')}
      </Typography>
      <DimensionUnitSelectField
        name="dimension_unit"
        label={t('packagingSpecificationForm.labels.unitOfMeasurement')}
      />
      <RangeField
        minName="min_width"
        maxName="max_width"
        label={t('packagingSpecificationForm.labels.width')}
        endAdornment={dimensionUnit}
      />
      <RangeField
        minName="min_height"
        maxName="max_height"
        label={t('packagingSpecificationForm.labels.height')}
        endAdornment={dimensionUnit}
      />
      <RangeField
        minName="min_length"
        maxName="max_length"
        label={t('packagingSpecificationForm.labels.length')}
        endAdornment={dimensionUnit}
      />

      <Typography variant="body1" fontWeight="bold">
        {t('packagingSpecificationForm.sections.density')}
      </Typography>
      <DensityUnitSelectField name="density_unit" label={t('packagingSpecificationForm.labels.density')} />
      <RangeField
        minName="min_density"
        maxName="max_density"
        label={t('packagingSpecificationForm.labels.density')}
        endAdornment={densityUnit}
      />
    </Stack>
  );
};
